import React from "react";

export default class BottomModalContent extends React.Component {
    constructor( props ) {
        super(props);

    }

    render() {
        if ( typeof this.props.currentState == "undefined" ) {
            return <div></div>;
        }

        return (
            <div>
                <h3 className="bottom-modal__title">
                    {this.props.currentState.obj.title}
                </h3>

                {this.props.currentState.obj.hasThumbnail &&
                <div className="bottom-modal__thumbnail">
                    <img src={this.props.currentState.obj.thumbnailUrl} alt={this.props.currentState.obj.title}/>
                </div>}

                <div className="[ rte-content ]"
                     dangerouslySetInnerHTML={{__html: this.props.currentState.obj.content}}>
                </div>
            </div>
        );
    }

}
